// extracted by mini-css-extract-plugin
export var bubble = "_36-0";
export var container = "_36-f";
export var contrastBorder = "_36-g";
export var greyOut = "_36-2";
export var initialsColor0 = "_36-3";
export var initialsColor1 = "_36-4";
export var initialsColor10 = "_36-d";
export var initialsColor11 = "_36-e";
export var initialsColor2 = "_36-5";
export var initialsColor3 = "_36-6";
export var initialsColor4 = "_36-7";
export var initialsColor5 = "_36-8";
export var initialsColor6 = "_36-9";
export var initialsColor7 = "_36-a";
export var initialsColor8 = "_36-b";
export var initialsColor9 = "_36-c";
export var initialsWrapper = "_36-1";
export var large = "_36-l";
export var medium = "_36-k";
export var mediumSmall = "_36-j";
export var mediumSmallMedium = "_36-o";
export var micro = "_36-h";
export var small = "_36-i";
export var tiny = "_36-n";
export var xTiny = "_36-m";